<template>
  <div id="publishing-reviewer-board-add">
    <ipub-model :title="'Add Reviewer'"
                width="1100px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="reviewer-board-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-row>
          <ipub-col :span="9.5">
            <ipub-row :gutter="20">
              <ipub-col :span="4">
                <ipub-form-item prop="email"
                                label="Email">
                  <ipub-input placeholder="Email"
                              v-model.trim="params.email" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="firstName"
                                label="First Name">
                  <ipub-input placeholder="First Name"
                              v-model.trim="params.firstName" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="lastName"
                                label="Last Name">
                  <ipub-input placeholder="Last Name"
                              v-model.trim="params.lastName" />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="20">
              <ipub-col :span="2">
                <ipub-form-item prop="hindex"
                                label="H-index">
                  <ipub-input placeholder="H-index"
                              number
                              v-model="params.hindex" />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="10">
                <ipub-form-item prop='hindexUrl'
                                label="H-Index URL">
                  <ipub-input placeholder="H-Index URL"
                              v-model.trim="params.hindexUrl" />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </ipub-col>
          <ipub-col :span="2.5"
                    class="relative">
            <ipub-form-item prop="icon">
              <div class="upload-content right-option">
                <div class="upload-content-img">
                  <ipub-upload-cropper @change="(e)=>{handleUpload('icon', e)}"
                                       :canWidth="105"
                                       :canHeight="130"
                                       :scales="2"
                                       :imgUrl="params.icon?domain+'/'+params.icon:domain+'/imageFile/icon.svg'" />
                </div>
              </div>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="affiliations"
                        label="Affiliations">
          <div v-for="(item, index) in params.affiliations"
               class="mar-b-10"
               :key="'params.affiliations'+index">
            <ipub-input placeholder="Affiliations"
                        suffixIcon="iconClose"
                        @blur="getMore('affiliation')"
                        @iconClick="delMore('affiliations',index)"
                        v-model.trim="params.affiliations[index]" />
          </div>
          <ipub-button type="primary"
                       icon="iconAdd"
                       @click="addMore('affiliations')"
                       style="width:240px"
                       plain>Add Affilications</ipub-button>
        </ipub-form-item>
        <ipub-form-item prop="journalIdList"
                        label="">
          <div class="ipub-p1 mar-b-10"
               slot="label">
            Journal(s) Would Like to Review
            <font class="key-color">*</font>
          </div>
          <ipub-select v-model="params.journalIdList"
                       placeholder="Choose the journal(s) you would like to review"
                       mode="multiple"
                       :options="journalList" />
        </ipub-form-item>
        <ipub-form-item label="Research Keywords"
                        prop="keywords">
          <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                      tag
                      v-model.trim="params.keywords" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import { reviewer } from '@/api/reviewer'
import help from '@/utils/help'


export default {
  props: {
    keyword: [],
    isVisable: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
    journalList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      params: {
        journalIdList: [],
        affiliations: [''],
        keywords: [],
      },
      rules: {},
      personJournalIdList: [],
      // categoryList: [],
      degreesList: [],
      isCropper: false,
      canWidth: 200,
      canHeight: 225,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      title: 'getTitle',
      degree: 'getDegree',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          affiliations: [''],
          keywords: [],
        }
      } else {
        this.params = Object.assign(this.params, this.inputData)
      }
    },
  },
  mounted () {
    this.getRules()
  },
  methods: {
    //上传文件(cv/头像)
    async handleUpload (key, files) {
      const file = files[0]
      const imgFiles = ['icon']
      const pdfFiles = ['rcv']
      const imgTypes = ['image/jpeg', 'image/png']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (imgFiles.includes(key)) {
        rightType = imgTypes.includes(file.type)
      } else if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/journal/${this.inputData.journalId
        }/reviewer/${key}/${help.guid()}`
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, key + 'Name', file.name)
      this.$set(this.params, key, url)
    },
    cancelCopper () {
      this.isCropper = false
    },
    uploadCropper () {
      this.isCropper = true
    },

    delFile (key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },
    dialogCancel () {
      this.showReason = false
    },
    addMore (key) {
      this.params[key].push('')
    },
    delMore (key, index) {
      if (this.params[key].length === 1) {
        return
      }
      this.params[key].splice(index, 1)
    },
    getMore (key) {
      const arr = []
      this.params[key + 's'].forEach(item => {
        if (item) {
          arr.push(item)
        }
      })
      this.params[key] = arr.join(';')
    },
    async confirm () {
      this.showReason = false
      const flag = this.$refs['reviewer-board-add-form'].validate()
      if (
        !this.params.journalIdList ||
        (this.params.journalIdList && this.params.journalIdList.length === 0)
      ) {
        this.$message.error({
          title: 'Error',
          content: 'Journal(s) Would Like to Review  cannot be empty!'
        })
        return
      }
      if (flag) {
        const data = Object.assign(this.params, {
          journalId: this.inputData.journalId,
        })

        let res = ''
        data.released = false
        data.affiliation = data.affiliations.join(',')
        data.keyword = data.keywords.join(';')
        res = await reviewer.add(data)
        this.$message.success({
          title: 'Success',
          content: 'This Reviewer has been saved!'
        })
        this.$emit('confirm', res || data)
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        email: [
          {
            required: true,
            message: 'Email' + this.LANGUAGE[this.language].noEmpty
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email'
          },
        ],
        // titleCode: [
        //   {
        //     required: true,
        //     message: 'Title' + this.LANGUAGE[this.language].noEmpty
        //   }
        // ],
        firstName: [
          {
            required: true,
            message: 'First Name' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        lastName: [
          {
            required: true,
            message: 'Last Name' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        hindex: [
          {
            required: true,
            message: 'H-index' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        hindexUrl: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'H-index Url'
          }
        ],
        affiliations: [
          {
            required: true,
            message: 'Affiliation' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        keywords: [
          {
            required: true,
            message: 'Keywords' + this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#publishing-reviewer-board-add {
  .upload-content {
    height: 140px;
    width: 135px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-img {
      border-radius: 4px;
      height: 140px;
      width: 125px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
